import React from 'react';
import { Square, Circle, LayoutPanelLeft, LayoutGrid } from 'lucide-react';

/**
 * Компонент выбора формы бетонной конструкции
 */
const ShapeSelectionSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="mb-6">
      <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
        Выберите форму конструкции
      </div>
      
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {/* Прямоугольник */}
        <label 
          className={`relative flex flex-col items-center p-4 border rounded-lg cursor-pointer transition-colors
            ${formData.shapeType === 'rectangle' 
              ? 'bg-cyan-50 border-cyan-300 dark:bg-cyan-900/30 dark:border-cyan-700' 
              : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="shapeType"
            value="rectangle"
            checked={formData.shapeType === 'rectangle'}
            onChange={handleInputChange}
            className="sr-only"
            aria-label="Прямоугольник"
          />
          <Square 
            className={`w-10 h-10 mb-2 ${formData.shapeType === 'rectangle' ? 'text-cyan-500' : 'text-gray-400'}`} 
          />
          <span className={`text-sm font-medium ${formData.shapeType === 'rectangle' ? 'text-cyan-700 dark:text-cyan-300' : 'text-gray-700 dark:text-gray-300'}`}>
            Прямоугольник
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            Плита, фундамент
          </span>
        </label>

        {/* Цилиндр */}
        <label 
          className={`relative flex flex-col items-center p-4 border rounded-lg cursor-pointer transition-colors
            ${formData.shapeType === 'cylinder' 
              ? 'bg-cyan-50 border-cyan-300 dark:bg-cyan-900/30 dark:border-cyan-700' 
              : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="shapeType"
            value="cylinder"
            checked={formData.shapeType === 'cylinder'}
            onChange={handleInputChange}
            className="sr-only"
            aria-label="Цилиндр"
          />
          <Circle 
            className={`w-10 h-10 mb-2 ${formData.shapeType === 'cylinder' ? 'text-cyan-500' : 'text-gray-400'}`} 
          />
          <span className={`text-sm font-medium ${formData.shapeType === 'cylinder' ? 'text-cyan-700 dark:text-cyan-300' : 'text-gray-700 dark:text-gray-300'}`}>
            Цилиндр
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            Колонна, свая
          </span>
        </label>

        {/* L-образная форма */}
        <label 
          className={`relative flex flex-col items-center p-4 border rounded-lg cursor-pointer transition-colors
            ${formData.shapeType === 'l_shape' 
              ? 'bg-cyan-50 border-cyan-300 dark:bg-cyan-900/30 dark:border-cyan-700' 
              : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="shapeType"
            value="l_shape"
            checked={formData.shapeType === 'l_shape'}
            onChange={handleInputChange}
            className="sr-only"
            aria-label="L-образная форма"
          />
          <LayoutPanelLeft 
            className={`w-10 h-10 mb-2 ${formData.shapeType === 'l_shape' ? 'text-cyan-500' : 'text-gray-400'}`} 
          />
          <span className={`text-sm font-medium ${formData.shapeType === 'l_shape' ? 'text-cyan-700 dark:text-cyan-300' : 'text-gray-700 dark:text-gray-300'}`}>
            L-образная
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            Сложный фундамент
          </span>
        </label>

        {/* Произвольная форма */}
        <label 
          className={`relative flex flex-col items-center p-4 border rounded-lg cursor-pointer transition-colors
            ${formData.shapeType === 'arbitrary' 
              ? 'bg-cyan-50 border-cyan-300 dark:bg-cyan-900/30 dark:border-cyan-700' 
              : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
            }`}
        >
          <input
            type="radio"
            name="shapeType"
            value="arbitrary"
            checked={formData.shapeType === 'arbitrary'}
            onChange={handleInputChange}
            className="sr-only"
            aria-label="Произвольная форма"
          />
          <LayoutGrid 
            className={`w-10 h-10 mb-2 ${formData.shapeType === 'arbitrary' ? 'text-cyan-500' : 'text-gray-400'}`} 
          />
          <span className={`text-sm font-medium ${formData.shapeType === 'arbitrary' ? 'text-cyan-700 dark:text-cyan-300' : 'text-gray-700 dark:text-gray-300'}`}>
            Произвольная
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            Сложная форма
          </span>
        </label>
      </div>

      {errors.shapeType && (
        <p className="mt-1 text-xs text-red-500 dark:text-red-400">
          {errors.shapeType}
        </p>
      )}

      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800 text-sm text-blue-700 dark:text-blue-300">
        <p>Выберите форму, наиболее близкую к вашей конструкции, или используйте произвольную форму для сложных проектов.</p>
      </div>
    </div>
  );
};

export default ShapeSelectionSection;